export function isNavigationRouteActive(path, location) {
  if (!path) return false;
  const [pathname, search = ''] = path.split('?');
  if (pathname === '/admin') return location.pathname === pathname;
  if (location.pathname !== pathname && !location.pathname.startsWith(`${pathname}/`)) return false;
  const target = new URLSearchParams(search);
  const current = new URLSearchParams(location.search || '');
  // These views share one pathname. Filters and booking detail parameters do
  // not change which navigation item owns the current view.
  if (pathname === '/admin/product-monitoring/reservations') {
    if ((target.get('view') || 'all') !== (current.get('view') || 'all')) return false;
  }
  return [...target].every(([key, value]) => current.get(key) === value);
}
